(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/emp-video-player/assets/javascripts/helpers/setup-footer.js') >= 0) return;  svs.modules.push('/components/components/emp-video-player/assets/javascripts/helpers/setup-footer.js'); 'use strict';


const registerFooterComponents = () => {
  const Button = empPlayer.videojs.getComponent('Button');
  const Component = empPlayer.videojs.getComponent('Component');
  const DurationInfo = empPlayer.videojs.extend(Component, {
    constructor: function (player, options) {
      Component.apply(this, arguments);
      player.on('timeupdate', () => {
        const durationTime = empPlayer.videojs.formatTime(player.duration());
        const currentTime = empPlayer.videojs.formatTime(player.currentTime());
        const updated = "".concat(currentTime, " / ").concat(durationTime);
        this.updateTextContent(updated);
      }); 

      if (options.text) {
        this.updateTextContent(options.text);
      }
    },
    createEl: function () {
      return empPlayer.videojs.dom.createEl('div', {
        className: 'vjs-duration-info'
      });
    },
    updateTextContent: function (text) {
      if (typeof text !== 'string') {
        text = ' ';
      }

      empPlayer.videojs.dom.emptyEl(this.el());
      empPlayer.videojs.dom.appendContent(this.el(), text);
    }
  });
  const FooterButton = empPlayer.videojs.extend(Button, {
    constructor: function (player, options) {
      Button.apply(this, arguments);
      const footerButton = options.footerButton;
      this.customOnClick = footerButton.customOnClick;
      this.addClass('icon');
      this.addClass(footerButton.icon);
      this.controlText(footerButton.controlText);

      if (footerButton.customClass) {
        this.addClass(footerButton.customClass);
      }
    },
    handleClick: function () {
      this.customOnClick();
    }
  });
  empPlayer.videojs.registerComponent('FooterButton', FooterButton);
  empPlayer.videojs.registerComponent('DurationInfo', DurationInfo);
};

const setupFooter = options => {
  const player = options.player; 

  player.getChild('controlBar').removeChild('DurationInfo');
  player.getChild('controlBar').removeChild('FooterButton');
  player.off('fullscreenchange');

  if (options.footerButton) {
    player.getChild('controlBar').addChild('FooterButton', {
      footerButton: options.footerButton
    }, 3);
    player.getChild('controlBar').getChild('FooterButton').toggleClass('vjs-hidden', document.fullscreenElement === player.el());
    player.on('fullscreenchange', function () {
      player.getChild('controlBar').getChild('FooterButton').toggleClass('vjs-hidden', document.fullscreenElement === player.el());
    });
  }

  if (options.showVideoDuration) {
    player.getChild('controlBar').addChild('DurationInfo');
  }
};

svs.components.emp_video_player.helpers.setupFooter = {
  setupFooter: setupFooter,
  registerFooterComponents: registerFooterComponents
};
 })(window);